export default __webpack_public_path__ + "static/media/Lori.910cd004.jpg";